import createContext from '@ant-design/create-react-context';
var MenuContext = createContext({
  inlineCollapsed: false
});
export default MenuContext;